import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { AddOwnSchema } from '../../schemas/addSchema'
import { useOnCompleted } from '../useOnCompleted'
import { toDTO } from './api/mapper'
import { CREATE_OWN_WORKSPACE_BIDDER } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseCreateOwnWorkspaceBidder } from './types'

export const useCreateOwnWorkspaceBidder = (): UseCreateOwnWorkspaceBidder => {
  const { workspaceId } = useWorkspaceParam()
  const { onCompleted } = useOnCompleted()
  const [errors, setErrors] = useState<FieldErrors<AddOwnSchema>>({})

  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: CREATE_OWN_WORKSPACE_BIDDER,
    onCompleted: async (data: Data, variables: { input: Variables }): Promise<void> => {
      setErrors(onCompleted(variables.input.bidderCode, data))
    },
  })

  const createOwn = async (data: AddOwnSchema): Promise<void> => {
    await mutateAsync({ input: toDTO({ ...data, workspaceId }) })
  }

  return { createOwn, ownErrors: errors }
}
